import React, { useEffect, useRef, useState, useLayoutEffect } from 'react';
import AnimatedWords from './AnimatedWords';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function TestimonialCard({ quote, name, title, avatar, designation, company }) {
    return (
        <article className="testi-card flex flex-col justify-between" data-card>
            <p className="quote text-sm md:text-base lg:text-lg">{quote}</p>
            <div className="byline flex justify-between">
                {/* <img src={avatar} alt={name} loading="lazy" decoding="async" /> */}
                <div className="person">
                    <div className="name text-sm md:text-base lg:text-lg">{name}</div>
                    <div className="role text-sm md:text-base">{title}</div>
                    <div className="role text-sm md:text-base">{designation}</div>
                    <div className="role text-sm md:text-base">@{company}</div>
                </div>
                <span aria-hidden="true">
                    <svg width="54" height="38" viewBox="0 0 94 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M94 22.2029V24.7091C93.1413 35.9166 83.2996 43.6881 72.9348 46.0501C72.4457 46.162 71.949 46.2928 71.4457 46.3222L73.0817 45.1791C82.0162 38.5564 86.6693 27.8171 82.802 16.9158C79.9907 8.98785 73.0703 3.07605 65.4154 0.00118677C78.1205 -0.114452 92.8863 8.22767 93.9185 22.0134C93.9261 22.1138 94 22.1906 94 22.202V22.2029Z" fill="#ED1B24" />
                        <path d="M24.302 57.1295C26.7588 54.993 28.8166 52.3911 30.3455 49.5087C31.8744 46.6262 32.8649 43.8405 30.1379 41.231C27.5446 38.7495 25.6631 37.0898 23.9475 33.7951C16.7039 19.8871 27.3939 6.69099 40.6289 2.70144C54.5141 -1.48431 73.8732 3.41803 79.1224 18.2464C84.22 32.6472 71.9718 44.4869 58.8392 47.3807C56.6174 47.8708 54.6307 47.886 52.4648 48.2111C50.497 48.5068 47.8942 50.9276 45.9691 51.9741C39.4725 55.5068 31.6413 56.8575 24.302 57.1285V57.1295ZM39.5474 22.0767C35.4232 22.1525 35.6498 28.652 40.0829 28.1553C43.626 27.7581 43.4033 22.0056 39.5474 22.0767ZM52.3122 22.0767C48.4648 22.1184 48.335 27.7951 51.9084 28.1534C56.3823 28.6027 56.4468 22.0312 52.3122 22.0767ZM65.3908 22.0767C61.2657 22.1525 61.479 28.6539 65.9263 28.1553C69.4742 27.7581 69.24 22.0065 65.3908 22.0767Z" fill="#ED1B24" />
                        <path d="M19.2118 16.564L17.7673 22.3639L2.88114 22.362C0.439449 22.3108 -0.931157 19.4019 0.728547 17.5412C1.09063 17.1355 2.0347 16.564 2.57024 16.564H19.2118Z" fill="#ED1B24" />
                        <path d="M26.8868 5.83542L25.5142 7.0866C24.2119 8.46194 22.9399 9.87331 21.9133 11.4733L21.6839 11.5567L8.75513 11.5548C6.35989 11.3482 5.34094 8.33967 6.99211 6.65342C7.26225 6.3776 8.15513 5.83447 8.5229 5.83447H26.8868V5.83542Z" fill="#ED1B24" />
                        <path d="M9.38358 33.0881C6.37222 32.6834 6.21772 28.018 9.26225 27.4066L17.9589 27.3706C18.0593 29.3459 18.7352 31.2151 19.2897 33.0881H9.38358Z" fill="#ED1B24" />
                    </svg>
                    {/* <img src="/images/comment_icon.png" width="20px" height="15px" /> */}
                </span>
            </div>
        </article>
    );
}

const Testimonials = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [cardsPerView, setCardsPerView] = useState(3);
    const containerRef = useRef(null);
    const carouselRef = useRef(null);

    const cards = [
        {
            quote:
                "Their reliability and on-time performance have been a game changer for our distribution network. Every dispatch is tracked in real time, and we always know exactly where our shipment is.",
            name: 'Rakesh Mehra',
            designation: 'Operations Manager',
            company: 'Omega Auto Components Pvt. Ltd.',
            avatar: '/images/profile_photo.webp',
        },
        {
            quote:
                "We've worked with this team for over four years now.Whether it's full truckloads or air express deliveries, their coordination and communication are always excellent. They've become our go- to logistics partner.",
            name: 'Rohan Patel',
            designation: 'Managing Director',
            company: 'Vivid Tools & Engineering',
            avatar: '/images/profile_photo.webp',
        },
        {
            quote:
                'From bonded warehousing to last-mile deliveries, their service execution is flawless. The team handles every shipment with professionalism and speed, giving us total confidence.',
            name: 'Neha Khanna',
            designation: 'Supply Chain Head',
            company: 'Axis Electronics India',
            avatar: '/images/profile_photo.webp',
        },
        {
            quote:
                'We often have urgent spare parts that must reach our dealers the same day. Their express and showroom delivery services are incredibly dependable — not a single delay in the past year.',
            name: 'Sunil Deshmukh',
            designation: 'Logistics Head',
            company: 'DriveTech Automotive Solutions',
            avatar: '/images/profile_photo.webp',
        },
        {
            quote:
                'They manage our multi-city movements with precision — from loading at factories to warehouse storage and final delivery. Their visibility tools and proactive updates really stand out.',
            name: 'Priya Sharma',
            designation: 'Procurement Manager',
            company: 'Global Fasteners Pvt. Ltd.',
            avatar: '/images/profile_photo.webp',
        },
    ];


    // Calculate responsive cards per view
    useEffect(() => {
        const updateCardsPerView = () => {
            const width = window.innerWidth;
            if (width <= 768) {
                setCardsPerView(1);
            } else if (width <= 1024) {
                setCardsPerView(2);
            } else {
                setCardsPerView(3);
            }
        };

        updateCardsPerView();
        window.addEventListener('resize', updateCardsPerView);
        return () => window.removeEventListener('resize', updateCardsPerView);
    }, []);

    // Calculate total slides
    const totalSlides = Math.ceil(cards.length / cardsPerView);
    const maxIndex = Math.max(0, totalSlides - 1);

    // Clamp currentIndex when cardsPerView changes
    useEffect(() => {
        if (currentIndex > maxIndex) {
            setCurrentIndex(maxIndex);
        }
    }, [cardsPerView, maxIndex, currentIndex]);

    const goToSlide = (index) => {
        setCurrentIndex(Math.max(0, Math.min(index, maxIndex)));
    };

    const goToPrev = () => {
        setCurrentIndex((prev) => Math.max(0, prev - 1));
    };

    const goToNext = () => {
        setCurrentIndex((prev) => Math.min(maxIndex, prev + 1));
    };

    // Update carousel transform
    useEffect(() => {
        const updateTransform = () => {
            if (carouselRef.current && carouselRef.current.parentElement) {
                const container = carouselRef.current.parentElement;
                const containerWidth = container.offsetWidth;
                if (containerWidth > 0) {
                    const gap = 24; // 24px gap
                    const cardWidth = (containerWidth - (gap * (cardsPerView - 1))) / cardsPerView;
                    const translateX = -(currentIndex * (cardWidth + gap));
                    carouselRef.current.style.transform = `translateX(${translateX}px)`;
                }
            }
        };

        updateTransform();
        // Also update on window resize to handle container size changes
        window.addEventListener('resize', updateTransform);
        return () => window.removeEventListener('resize', updateTransform);
    }, [currentIndex, cardsPerView]);

    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        const ctx = gsap.context(() => {
            const tl = gsap.timeline({
                defaults: { ease: 'power2.out' },
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: 'top 75%',
                    toggleActions: 'play none none none',
                    once: true
                }
            });
            const headingWords = containerRef.current?.querySelectorAll('.testi-head h2 [data-animated-word]');
            if (headingWords && headingWords.length) {
                tl.fromTo(headingWords, { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: 'power3.out', stagger: 0.06, clearProps: 'transform' }, 0);
            }
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <section id="testimonials" className="section testimonials alt">
            <div className="container" ref={containerRef}>
                <div className="testi-head">
                    <div className="container section-badge flex justify-center items-center gap-3 text-[16px] md:text-[20px]">
                        <div className="badge-dot"></div>
                        Customer Feedback
                    </div>
                    <h2><AnimatedWords auto={false} lines={["What Our Partners Say About"]} /></h2>
                </div>

                <div className="testi-carousel-wrapper">
                    <button
                        className="carousel-btn carousel-btn-prev"
                        onClick={goToPrev}
                        aria-label="Previous testimonials"
                        disabled={currentIndex === 0}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>

                    <div className="testi-carousel-container">
                        <div className="testi-carousel" ref={carouselRef}>
                            {cards.map((c, i) => (
                                <TestimonialCard key={i} {...c} />
                            ))}
                        </div>
                    </div>

                    <button
                        className="carousel-btn carousel-btn-next"
                        onClick={goToNext}
                        aria-label="Next testimonials"
                        disabled={currentIndex >= maxIndex}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                <div className="dots" role="tablist">
                    {Array.from({ length: totalSlides }).map((_, i) => (
                        <button
                            key={i}
                            className={`dot ${currentIndex === i ? 'is-active' : ''}`}
                            data-dot={i}
                            aria-label={`Slide ${i + 1}`}
                            onClick={() => goToSlide(i)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;


